<template>
  <v-app>
    <notifications />
    <v-app-bar
      dense
      :color="parametrosCoac.colorPrincipal"
      app
      dark
      fixed
      flat
      v-if="parametrosCoac"
    >
      <v-tabs
        grow
        :slider-color="parametrosCoac.colorSecundario"
        slider-size="5"
      >
        <v-tab @change="onTabChange(0)" class="font-weight-medium">
          <v-icon class="pr-4">mdi-cash-multiple</v-icon> CALCULADORA DE
          CRÉDITO</v-tab
        >
        <v-tab @change="onTabChange(1)" class="font-weight-medium">
          <v-icon class="pr-4">mdi-piggy-bank</v-icon> CALCULADORA DE DE AHORRO
          Y PLAZO FIJO</v-tab
        >
      </v-tabs>
    </v-app-bar>
    <v-app-bar v-else color="primary" app dark fixed flat>
      <img alt="ITlligen" src="logo.png" />
      &nbsp;
      <v-toolbar-title v-if="parametrosCoac"
        >Calculadora de Crédito</v-toolbar-title
      >
      <v-toolbar-title v-else>Calculadora de Crédito</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "App",
  data: () => ({ dondeIr: "/" }),
  methods: {
    ...mapActions(["setParametrosCoac", "setParametrosCoacAhorros"]),
    onTabChange(tab) {
      this.dondeIr = "/ahorros";
      if (tab == 0) {
        this.dondeIr = "/";
      }

      this.$router.push(this.dondeIr).catch(() => {});

      return;
    },
  },
  computed: {
    ...mapGetters({
      parametrosCoac: "getParametrosCoac",
    }),
  },
  created: function () {
    this.setParametrosCoac(1);
    this.setParametrosCoacAhorros(1);
    this.$router.push(this.dondeIr).catch(() => {});
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
